<template>
  <div class="gift-menber">
    <div class="gift-block">
      <div class="gift-top">
        <div class="txt1">剩余名额(个)</div>
        <div class="txt2">{{ userInfo.give_svip }}</div>
        <div class="txt3">如有结算金额请尽快结算</div>
        <div class="btn1" @click="handleJump('HELPOPEN')">我要赠送</div>
      </div>
      <div class="btm-block">
        <div class="btm1">
          <div class="txt1">已赠送名额</div>
          <div class="txt2">{{ detailObject.give_count }}</div>
        </div>
        <div class="btm1">
          <div class="txt1">赠送类型</div>
          <div class="txt2">{{ detailObject.give_title }}</div>
        </div>
      </div>
    </div>
    <div class="title">
      <div class="title-item cur">赠送记录</div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" class="list">
      <div class="item" v-for="(item, index) in list" :key="index" @click="handleJump(item)">
        <div class="item-con">
          <div class="txt-div">
            <div class="txt1">{{ item.title }}</div>
            <div class="txt2">{{ item.change }}</div>
          </div>
          <div class="txt-div">
            <div class="txt3">{{ item.create_time }} 注册</div>
            <div class="txt3">赠送成功</div>
          </div>
        </div>
        <img src="@/assets/images_member/per1 (53).png" class="item-arrow" alt="">
      </div>
    </van-list>
  </div>
</template>
<script>
import { svipGiveLog } from '@/api/person'
export default {
  name: 'giftMenber',
  data () {
    return {
      detailObject: {},
      list: [],
      loading: false,
      finished: false,
      page: 1,
      num: 10
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    },
  },

  mounted () {
  },

  methods: {
    // handleFunction () {
    //   cusotm().then(res => {
    //     this.cusotmObject = res.data
    //   })
    // },
    onLoad () {
      svipGiveLog({
        page: this.page,
        num: this.num
      }).then(res => {
        this.detailObject = res.data
        if (res.data.lists.length < this.num) {
          this.finished = true
        }
        this.list = this.list.concat(res.data.lists)
        this.page++
        // 加载状态结束
        this.loading = false
      })
    },
    handleJump (item) {
      if (item === 'HELPOPEN') {
        this.$router.push({
          path: `/helpOpen`,
          query: {
            title: this.detailObject.give_title
          }
        })
        return
      }
      this.$router.push({
        path: `/customDetails?id=${item.trigger_uid}`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.gift-menber {
  background-color: #1E2020;
  min-height: 100vh;
  width: 100vw;
  padding: 14px;
  box-sizing: border-box;

  .gift-block {
    border-radius: 10px;
    background-color: #292B2A;
    padding: 0 14px;
    box-sizing: border-box;

    .gift-top {
      border-bottom: 1px solid #535654;
      position: relative;
      padding: 20px 0;
      box-sizing: border-box;

      .txt1 {
        font-size: 14px;
        color: #FFFFFF;
        font-weight: 500;
        line-height: 14px;
        margin-bottom: 14px;
      }

      .txt2 {
        font-size: 24px;
        color: #F0E1C0;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 12px;
      }

      .txt3 {
        color: #999999;
        font-size: 12px;
        font-weight: 500;
        line-height: 12px;
      }

      .btn1 {
        width: 84px;
        height: 34px;
        text-align: center;
        line-height: 34px;
        border-radius: 100px;
        position: absolute;
        right: 0;
        top: 43px;
        color: #504632;
        font-size: 14px;
        font-weight: 600;
        background-color: #F0E1C0;
      }
    }

    .btm-block {
      display: flex;
      padding-top: 20px;
      padding-bottom: 23px;
      box-sizing: border-box;

      .btm1 {
        flex: 1;
        display: flex;
        flex-direction: column;

        .txt1 {
          font-size: 12px;
          color: #999999;
          font-weight: 500;
          margin-bottom: 12px;
        }

        .txt2 {
          font-size: 18px;
          color: #FFFFFF;
          font-weight: 500;
          line-height: 18px;
        }
      }
    }
  }

  .title {
    position: relative;
    height: 64px;
    line-height: 64px;
    display: flex;

    .title-item {
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 400;
      margin-right: 25px;

      &.cur {
        font-size: 18px;
        color: #F0E1C0;
        font-weight: 600;

        &::after {
          position: absolute;
          bottom: 10px;
          width: 38px;
          height: 2px;
          background-color: #F0E1C0;
          left: 8px;
          content: "";
        }
      }
    }

  }

  .list {
    background-color: #292B2A;
    border-radius: 6px 6px 0px 0px;
    padding: 0 14px;
    box-sizing: border-box;

    .item {
      padding: 20px 0;
      box-sizing: border-box;
      border-bottom: 1px solid #666666;
      display: flex;
      justify-content: space-between;
      align-items: center;

      &:last-child {
        border: none;
      }

      .item-cover {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 8px;
      }

      .item-arrow {
        width: 8px;
        height: 16px;
        margin-left: 8px;
      }

      .item-con {
        flex: 1;

        .txt-div {
          display: flex;
          justify-content: space-between;
          align-items: center;
          line-height: 16px;

          .txt1 {
            font-size: 16px;
            color: #FFFFFF;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            width: 200px;
          }

          .txt2 {
            font-size: 16px;
            color: #F0E1C0;
          }

          .txt3 {
            font-size: 12px;
            color: #999999;
            line-height: 8px;
            margin-top: 8px;
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/personal/giftMenber.vue